import React from 'react'

// components
import { KanbanCardJob } from './card.job';
import { KanbanCardJobFaulty } from './card.job.faulty';

export const KanbanStageJobStatus = (props) => {

  // input
  const { title, jobs = [] } = props;

  return (
    <div className="w-full md:p-4 md:bg-slate-100 md:rounded-lg md:border md:border-gray-200 md:min-h-96 md:w-72 2xl:w-72">
      <div className="flex justify-between items-center mb-2">
        <h3 className="text-lg font-bold mb-2">{title}</h3>
        <button className="block md:hidden text-blue-500 cursor-pointer">
          All List &rarr;
        </button>
      </div>
      
      <div className="flex overflow-x-auto space-x-2 md:flex-col md:space-y-2 md:space-x-0">
        {jobs.map((item, index) => {
          // if(item.product.metadata.subtype === 'faulty') return <KanbanCardJobFaulty key={item.job_id} {...item}  />

          return <KanbanCardJob key={item.job_id} {...item}  />
        })}
      </div>
    </div>
  );
};
